import {
  EditAppointmentActionItem,
  OpenDrawerAppointmentActionItem,
} from "@/modules/patients/agenda/teleconsultation/appointment-action-menu/appointment-action-menu-item"
type OngoingAppointmentActionMenuProps = {
  isEditMode: boolean
  onClickEdit: React.MouseEventHandler<HTMLDivElement>
  onClickOpenDrawer: React.MouseEventHandler<HTMLDivElement>
}

export const OngoingAppointmentActionMenu = ({
  isEditMode,
  onClickEdit,
  onClickOpenDrawer,
}: OngoingAppointmentActionMenuProps) => {
  return isEditMode ? (
    <>
      <EditAppointmentActionItem onClick={onClickEdit} />
      <OpenDrawerAppointmentActionItem onClick={onClickOpenDrawer} />
    </>
  ) : (
    <OpenDrawerAppointmentActionItem onClick={onClickOpenDrawer} />
  )
}
